import axios from "axios";
import Instense from "./Axios-config";
import { API_ROOT } from "./Api-config";
 
export class DocumentService {

 

 


public static GetDocumentslist = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Documents/GetDocumentslist`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};
 
 public static GetDocument = async (request: any): Promise<any | null> => {
   let storage = JSON.parse(localStorage.getItem("storage")!);
   let tenantID = storage === null ? 0 : (storage.tenantID as any);
    
   request.tenantId = tenantID;
   const url = `/Transaction/GetDocuments`;
   return Instense.get(url, { params: request }).then((response) => {
     let result = response.data.result as any;
     return result;
   });
 };
 
 public static GetAllDocument = async (request: any): Promise<any | null> => {
   let storage = JSON.parse(localStorage.getItem("storage")!);
   let tenantID = storage === null ? 0 : (storage.tenantID as any);
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
   request.tenantId = tenantID;
   const url = `/Transaction/GetAllDocuments`;
   return Instense.get(url, { params: request }).then((response) => {
     let result = response.data.result as any;
     return result;
   });
 };
 
 public static SaveDocuments = async (request: any): Promise<any[] | null> => {
   let storage = JSON.parse(localStorage.getItem("storage")!);
   let tenantID = storage === null ? 0 : (storage.tenantID as any);
   const raw = localStorage.getItem("locationId");
   const locationId = raw === null ? 0 : Number(raw) ;
            
   request.locationId = locationId;
   request.tenantId = tenantID;
   const url =`/Transaction/SaveDocument`;
   return Instense.post(url,request).then((response) => {
     let result = response.data as any;
     return result;
   });
 };
   
 public static GetDepartment = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/Department/GetDepartments`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data as any;
    return result;
  });
};

public static GetDocumentTypes = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
   
  request.tenantid = tenantID;
  const url = `/DocumentType/GetDocumentTypes`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data as any;
    return result;
  });
};



public static SaveDocumentTypes = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.TenantId = tenantID;

  const queryParams = new URLSearchParams(request).toString();

  const url = `/DocumentType/CreateDocumentType?${queryParams}`;

  return Instense.post(url).then((response) => {
    let result = response.data as any;
    return result;
  });
};


public static CreateDocumentCategory = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.TenantId = tenantID;

  const queryParams = new URLSearchParams(request).toString();

  const url = `/DocumentType/CreateDocumentCategory?${queryParams}`;

  return Instense.post(url).then((response) => {
    let result = response.data as any;
    return result;
  });
};


public static SaveDepartment = async (request: any): Promise<any[] | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.TenantId = tenantID;

  const queryParams = new URLSearchParams(request).toString();

  const url = `/Department/CreateDepartment?${queryParams}`;

  return Instense.post(url).then((response) => {
    let result = response.data as any;
    return result;
  });
};

public static SaveDocumentFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  const raw = localStorage.getItem("locationId");
  const locationId = raw === null ? 0 : Number(raw) ;
            
  request.locationId = locationId;
  request.tenantId = tenantID;

  const url = `/Transaction/SaveDocumentFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data as any;
    return result;
  });

};

public static SaveDocDetailFile = async (
  request: any, files: any[]
): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : storage.tenantID as any;
  request.tenantId = tenantID;

  const url = `/Transaction/SaveDocDetailFile`;
  const formData: FormData = new FormData();
  files.forEach(element => {
    formData.append('file', element);
  });

  formData.append('formField', JSON.stringify(request));
  return Instense.post(url, formData).then((response) => {
    let result = response.data.result as any;
    return result;
  });

};


public static GetDocListAll = async (request: any): Promise<any | null> => {
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);

  request.tenantid = tenantID;
  const url = `/Transaction/GetDocumentMaster`;
  return Instense.get(url, { params: request }).then((response) => {
    let result = response.data.result as any;
    return result;
  });
};

public static SaveDoc = async (request: any): Promise<any> => {
   
  let storage = JSON.parse(localStorage.getItem("storage")!);
  let tenantID = storage === null ? 0 : (storage.tenantID as any);
  let userName = storage === null ? "" : (storage.userName as any);
  // request.tenantid = tenantID;
  const url = `/Transaction/UpdateDocumentMasters`;
  return Instense.post(url, request).then((response) => {
      let result = response.data.result as any[];
      return result;
  });
};

}